export default "__VITE_ASSET__IDkdG9j4__"